import { render, staticRenderFns } from "./TelevisionsFormComponent.vue?vue&type=template&id=95c95810&scoped=true&"
import script from "./TelevisionsFormComponent.vue?vue&type=script&lang=js&"
export * from "./TelevisionsFormComponent.vue?vue&type=script&lang=js&"
import style0 from "./TelevisionsFormComponent.vue?vue&type=style&index=0&id=95c95810&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "95c95810",
  null
  
)

export default component.exports